"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderTest = void 0;
const tslib_1 = require("tslib");
require("../../../../TdWebtoolkitControls/controls/Wizard/Wizard");
const Utilities_1 = require("../../../../TdWebtoolkitControls/javascript/Utilities");
const synWizard_tests_steps_1 = require("./synWizard_tests.steps");
let markup = require("./synWizard_tests.tmpl.htm");
const destroyWizardAsync = ($wizard) => {
    return new Promise((resolve) => {
        if ($wizard.data("synWizard")) {
            $wizard.synWizard("cleanup").then((e) => {
                Utilities_1.synUtil.Notifications.info("[wizard] cleanup executed.");
                $wizard.synWizard("destroy");
                resolve();
            });
        }
        else
            resolve();
    });
};
const createWizardAsync = ($wizard) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    yield destroyWizardAsync($wizard);
    yield $wizard
        .on("beginInit endInit synWizardFinish synWizardCancel", (e) => {
        Utilities_1.synUtil.Notifications.info("[wizard] " + e.type + " event raised.");
    })
        .synWizard({
        WizardSteps: synWizard_tests_steps_1.createSteps(getDeterministic()),
        OutputDebugGraph: false,
        WizardName: "synWizard_tests",
        HeaderRenderingMode: getRenderingMode()
    });
});
const getDeterministic = () => {
    return $("#testContentPane").find(".checkBoxDeterministic").is(":checked");
};
const getRenderingMode = () => {
    const $selectedRadio = $("#testContentPane").find(".headerTypeFieldSet > input.radio:checked");
    if ($selectedRadio.hasClass("radioAdaptive"))
        return "Adaptive";
    return undefined;
};
function renderTest() {
    $("#testContentPane").html(markup);
    const $wizardDiv = $("#testContentPane").find(".wizardDiv");
    $("#testContentPane").find(".headerTypeFieldSet > input.radio").on("change", () => {
        if ($wizardDiv.data("synWizard"))
            createWizardAsync($wizardDiv);
    });
    $("#testContentPane").find(".checkBoxDeterministic").on("change", () => {
        if ($wizardDiv.data("synWizard"))
            createWizardAsync($wizardDiv);
    });
    $("#testContentPane").find(".createButton")
        .click((_e) => {
        createWizardAsync($wizardDiv);
        $destroyButton.removeAttr("disabled");
    });
    const $destroyButton = $("#testContentPane").find(".destroyButton")
        .click((_e) => {
        destroyWizardAsync($wizardDiv);
        $destroyButton.attr("disabled", "disabled");
    });
}
exports.renderTest = renderTest;
